import _ from "underscore"
import axios from "axios"

class Wagtail {
  constructor() {
    if (/colreps/.test(window.location.hostname) || /colombia/.test(window.location.hostname)) {
      this.api = "https://wagtail.fitnesscolombia.org/api/v1"
    } else {
      this.api = "https://wagtail.creafitness.com/api/v1"
    }
  }

  getEntries(category=null, blog=true) {
    let blogSuffix = (blog) ? "&blog=1" : "&blog=0"
    let categorySuffix = (category) ? `&category=${category}` : ''
    return axios.get(`${this.api}/entries/?cache=1&limit=99${categorySuffix}${blogSuffix}`)
  }

  getCategories(slugs) {
    return axios.get(`${this.api}/categories/?slugs=${slugs.join(",")}`)
  }

  getEntry(slug, blog=true) {
    let blogSuffix = (blog) ? "&blog=1" : "&blog=0"
    return axios.get(`${this.api}/entries/?cache=1&limit=1&slug=${slug}${blogSuffix}`)
  }

  getResourceTree() {
    return axios.get(`${this.api}/resource-tree/`)
  }

  getResource(slug) {
    return axios.get(`${this.api}/resources/?slug=${slug}`)
  }

  getDiscountCategories() {
    return axios.get(`${this.api}/discount-categories/`)
  }

  getDiscounts(limit=8, filters={}) {
    let queryString = ""
    if (filters.page) queryString += `&page=${filters.page}`
    if (filters.category) queryString += `&category=${filters.category}`
    if (filters.slug) queryString += `&slug=${filters.slug}`
    if (filters.plan) queryString += `&plan=${filters.plan}`
    let url = `${this.api}/discounts/?limit=${limit}${queryString}`

    return axios.get(url)
  }

  getResources(limit=4, filters) {
    let queryString = ""
    if (filters.page) queryString += `&page=${filters.page}`
    if (filters.query) queryString += `&query=${filters.query}`
    if (filters.topic) queryString += `&topic=${filters.topic}`
    if (filters.plan) queryString += `&plan=${filters.plan}`
    if (filters.family) queryString += `&family=${filters.family}`
    let url = `${this.api}/resources/?limit=${limit}${queryString}`

    return axios.get(url)
  }
}

export default new Wagtail()



// WEBPACK FOOTER //
// ./src/components/services/Wagtail.js